import { render } from "./Favorite_ads.vue?vue&type=template&id=5b515f3a"
import script from "./Favorite_ads.vue?vue&type=script&lang=js"
export * from "./Favorite_ads.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__